import { boot } from "quasar/wrappers";
import * as Sentry from "@sentry/vue";

export default boot(({ app, router }) => {
  if (process.env.VUE_APP_ENV === "local") return;


  Sentry.init({
    app,
    dsn: "https://6a57a0595b84e0099d584cfc7b247291@o4508650764173312.ingest.us.sentry.io/4509048692211712",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],

    normalizeDepth: 4,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [
      "localhost",
      /https:\/\/.*\.haii\.io/,
      /https:\/\/.*\.co.kr/,
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.VUE_APP_ENV,
  });
});
